export default {
      id: "ic_show-usage",
      viewBox: "0 0 24 16",
      url: "/" + "images/icons.3.109.2.svg#ic_show-usage",
      toString: function () {
        return this.url;
      }
    }